// extracted by mini-css-extract-plugin
module.exports = {"btnUpload":"UploadBtn_btnUpload__1xlXa"};